const vimeoConsentLabels = {
    de: {
        title: 'Vimeo Video laden',
        reject: 'ablehnen',
        confirm: 'Video laden',
        infoText: 'An dieser Stelle laden wir ein externes Video von Vimeo.<br>Dabei werden Daten mit den vimeo Servern ausgetauscht.<br>Weitere Infos dazu finden Sie in den <a href="https://vimeo.com/privacy" target="_blank" rel="noopener">Datenschutzbedingungen</a> von vimeo/Google.'
    },
    en: {
        title: 'Vimeo video loading',
        reject: 'reject',
        confirm: 'load video',
        infoText: 'An external video will be loaded from Vimeo.<br>This includes in user data beeing sent to the vimeo server.<br>More info at <a href="https://vimeo.com/privacy" target="_blank" rel="noopener">privacy policy</a> at vimeo/Google.'
    },
    es: {
        title: 'Cargar vídeo de vimeo',
        reject: 'rechazar',
        confirm: 'cargar video',
        infoText: 'En este punto cargamos un vídeo externo de Vimeo.<br>En el proceso, se intercambian datos con los servidores de vimeo.<br>Para más información, consulte <a href="https://vimeo.com/privacy" target="_blank" rel="noopener">la política de privacidad</a> de vimeo/Google.'
    }
}

export default vimeoConsentLabels;
